import "./VisualLegendHorizontal.scss";
import React from "react";
import { Button, ButtonType } from "../Button";
import { ButtonFrameworkVariant } from "../ButtonFramework";
import { ShadedPattern } from "../../MMM/FillPatterns/ShadedPattern";
import { ReactComponent as DemandCaptureIcon } from "./DemandCapture.svg";
import { ReactComponent as DemandGenIcon } from "./DemandGen.svg";
import { TooltipOverlay } from "../TooltipOverlay/TooltipOverlay";
import { OverlayTrigger } from "../OverlayTrigger";
import { SPEND_AND_EFFECT_GLOSSARY_DEFINITIONS } from "../SpendAndEffectModal/SpendAndEffectGlossary";

export const VisualLegendHorizontal: React.FC<{}> = () => {
  return (
    <div className="horizontalLegend">
      <div className="label">Legend:</div>
      <TooltipOverlay
        tooltipChildren={SPEND_AND_EFFECT_GLOSSARY_DEFINITIONS.Actualized}
        design="primary"
        multiline
        placement={OverlayTrigger.PLACEMENTS.BOTTOM.CENTER}
      >
        <Button
          className="first"
          design="secondary"
          size="sm"
          type={ButtonType.EMPTY}
          variant={ButtonFrameworkVariant.LEADING_ICON}
          icon={<div className="emptySquare"></div>}
        >
          Actualized
        </Button>
      </TooltipOverlay>
      <TooltipOverlay
        tooltipChildren={SPEND_AND_EFFECT_GLOSSARY_DEFINITIONS.Reduced}
        design="primary"
        multiline
        placement={OverlayTrigger.PLACEMENTS.BOTTOM.CENTER}
      >
        <Button
          design="secondary"
          size="sm"
          type={ButtonType.EMPTY}
          variant={ButtonFrameworkVariant.LEADING_ICON}
          icon={<ShadedPattern color="darkgray" />}
        >
          Reduced
        </Button>
      </TooltipOverlay>
      <TooltipOverlay
        tooltipChildren={SPEND_AND_EFFECT_GLOSSARY_DEFINITIONS.Added}
        design="primary"
        multiline
        placement={OverlayTrigger.PLACEMENTS.BOTTOM.CENTER}
      >
        <Button
          design="secondary"
          size="sm"
          type={ButtonType.EMPTY}
          variant={ButtonFrameworkVariant.LEADING_ICON}
          icon={<ShadedPattern color="white" backgroundColor="darkgray" id="Negdarkgray" />}
        >
          Added
        </Button>
      </TooltipOverlay>
      <div className="verticalDivider" />
      <TooltipOverlay
        tooltipChildren={SPEND_AND_EFFECT_GLOSSARY_DEFINITIONS["Demand Capture"]}
        design="primary"
        multiline
        placement={OverlayTrigger.PLACEMENTS.BOTTOM.CENTER}
      >
        <Button
          design="secondary"
          size="sm"
          type={ButtonType.EMPTY}
          variant={ButtonFrameworkVariant.LEADING_ICON}
          icon={<DemandCaptureIcon />}
        >
          Demand Capture
        </Button>
      </TooltipOverlay>
      <TooltipOverlay
        tooltipChildren={SPEND_AND_EFFECT_GLOSSARY_DEFINITIONS["Demand Generation"]}
        design="primary"
        multiline
        placement={OverlayTrigger.PLACEMENTS.BOTTOM.CENTER}
      >
        <Button
          design="secondary"
          size="sm"
          type={ButtonType.EMPTY}
          variant={ButtonFrameworkVariant.LEADING_ICON}
          icon={<DemandGenIcon />}
        >
          Demand Generation
        </Button>
      </TooltipOverlay>
    </div>
  );
};
